/**
 * decisionRefusalLog — a refused second answer, recorded so cross-surface
 * staleness is MEASURABLE rather than anecdotal.
 *
 * emuw-v1-5 `shared-decision-components` Phase 3 task 13 (DoD Monitoring).
 *
 * Emitted from the shared `DecisionCard`, NOT from either host. If each host
 * called it the record shape could drift — which is the exact failure this whole
 * story is closing, one level down. A module like this with no call site is that
 * failure with a green unit test on top, so the card's own spec asserts the call.
 *
 * IDENTITY ONLY. Instance id, step id, question key, host label. This line lands
 * in a browser console: no answer payload, no client context, no AM identity.
 *
 * In particular it does NOT carry `answeredWith`. Three reasons, any one of which
 * would be enough: it is a summarised answer rather than a fact, it resolves
 * asynchronously so it would be null at emit time anyway, and the thing being
 * measured is cross-surface STALENESS — how often two people are looking at the
 * same open decision — not what was decided.
 *
 * Single-line JSON so it survives WebView2's ~4KB per-call console truncation,
 * matching the add-in's own logger shape.
 */

/** Stable greppable token. Changing it changes whatever queries this. */
export const DECISION_REFUSED_EVENT = "decision_refused";

export interface DecisionRefusalDetails {
  instanceId: string | null;
  stepId: string | null;
  questionKey: string | null;
  host: "outlook-addin" | "ora";
}

export function logDecisionRefusal(details: DecisionRefusalDetails): void {
  try {
    console.warn(
      JSON.stringify({ event: DECISION_REFUSED_EVENT, ...details }),
    );
  } catch {
    // A telemetry line must never be the thing that breaks a decision surface.
  }
}
